<template>
  <div
    id="AgencySettingsComponent"
    class="col"
  >
    <error-component
      :show="showErrors"
      :errors="errors"
      :errors-array="errorsArray"
      @close="clear()"
    />
    <v-row>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-stretch"
      >
        <v-card class="card-width">
          <v-card-title>
            Details
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="settings.email"
              :rules="[...Rules.required, ...Rules.email, ...Rules.max(settings.email, 50)]"
              :counter="50"
              name="email"
              label="Email"
              required
              :disabled="loading"
              @keyup="changed()"
            />
            <v-text-field
              v-model="settings.phone"
              :rules="[...Rules.required, ...Rules.phone]"
              :counter="13"
              name="phone"
              label="Contact Number"
              required
              :disabled="loading"
              @keyup="changed()"
            />
            <v-textarea
              v-model="settings.address"
              :rules="[...Rules.required, ...Rules.string, ...Rules.max(settings.address, 150)]"
              :counter="150"
              name="address"
              label="Address"
              required
              :disabled="loading"
              @keyup="changed()"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-stretch"
      >
        <v-card class="card-width">
          <v-card-title>
            Social Media
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="settings.website_url"
              :rules="[...Rules.max(settings.website_url, 100)]"
              :counter="100"
              name="website_url"
              label="Website URL"
              prefix="https://"
              :disabled="loading"
              @keyup="changed()"
            />
            <v-text-field
              v-model="settings.twitter_handle"
              :rules="[...Rules.string, ...Rules.max(settings.twitter_handle, 15)]"
              :counter="15"
              name="twitter_handle"
              label="Twitter Handle"
              prepend-inner-icon="mdi-at"
              :disabled="loading"
              @keyup="changed()"
            />
            <v-text-field
              v-model="settings.facebook_page"
              :rules="[...Rules.string, ...Rules.max(settings.facebook_page, 50)]"
              :counter="50"
              name="facebook_page"
              label="Facebook URL"
              prefix="https://facebook.com/"
              :disabled="loading"
              @keyup="changed()"
            />
            <v-text-field
              v-model="settings.linkedin_profile"
              :rules="[...Rules.string, ...Rules.max(settings.linkedin_profile, 50)]"
              :counter="50"
              name="linkedin_profile"
              label="LinkedIn URL"
              prefix="https://www.linkedin.com/company/"
              :disabled="loading"
              @keyup="changed()"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-stretch"
      >
        <v-card class="card-width">
          <v-card-title>
            Work Finder's Agreement
          </v-card-title>
          <v-card-subtitle class="pb-5">
            Accepted files: doc, docx, pdf
          </v-card-subtitle>
          <v-card-text>
            <v-file-input
              v-model="work_finders_agreement"
              label="file upload"
              :rules="[...Rules.maxFileSize]"
              prepend-icon="mdi-file-document"
              accept=".doc,.docx,.pdf"
              placeholder="choose a document"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="primary"
                  class="mr-4"
                  :disabled="nullOrUndefined(work_finders_agreement)"
                  @click="fileUpload('wfa', work_finders_agreement)"
                >
                  upload
                </v-btn>
              </template>
            </v-file-input>
            <div
              v-if="wfa_error"
              id="wfaError"
              class="inlineError"
            >
              {{ wfa_error_text }}
            </div>
          </v-card-text>
          <v-card-actions class="px-4 align-bottom">
            <v-btn
              v-if="settings.work_finders_agreement"
              :href="'/agency-file/work-finders-agreement'"
              target="_blank"
              color="secondary"
              width="100%"
              :disabled="loading"
              outlined
            >
              view current agreement
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-stretch"
      >
        <v-card class="card-width">
          <v-card-title>
            Terms and Conditions
          </v-card-title>
          <v-card-subtitle class="pb-5">
            Accepted files: doc, docx, pdf
          </v-card-subtitle>
          <v-card-text>
            <v-file-input
              v-model="terms_conditions_url"
              label="file upload"
              :rules="[...Rules.maxFileSize]"
              prepend-icon="mdi-file-document"
              accept=".doc,.docx,.pdf"
              placeholder="choose a document"
            >
              <template v-slot:append-outer>
                <v-btn
                  color="primary"
                  class="mr-4"
                  :disabled="nullOrUndefined(terms_conditions_url)"
                  @click="fileUpload('terms', terms_conditions_url)"
                >
                  upload
                </v-btn>
              </template>
            </v-file-input>
            <v-sheet
              class="mt-4"
            >
              <div
                v-if="tnc_error"
                id="tncError"
                class="inlineError"
              >
                {{ tnc_error_text }}
              </div>
              <p>Check the box below to enable T&amp;C's on the registration form and require the candidate to sign</p>
              <v-checkbox
                v-model="settings.terms_conditions"
                label="show terms and conditions"
                :value="true"
                @change="changed()"
              />
            </v-sheet>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-btn
              v-if="settings.terms_conditions_url"
              :href="'/agency-file/terms-conditions'"
              target="_blank"
              color="secondary"
              width="100%"
              :disabled="loading"
              outlined
            >
              view current Terms
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!--<v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Bank Details
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="settings.bank_name"
                  :rules="Rules.string"
                  :counter="50"
                  name="bank_name"
                  label="Bank Name"
                  required
                  :disabled="loading"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="settings.account_number"
                  :rules="Rules.accountNumber"
                  :counter="10"
                  name="account_number"
                  label="Account Number"
                  required
                  :disabled="loading"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="settings.sort_code"
                  :rules="Rules.sortCode"
                  :counter="6"
                  name="sort_code"
                  label="Sort Code"
                  required
                  :disabled="loading"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>-->

    <v-row>
      <v-col
        cols="12"
        md="6"
        class="d-flex align-stretch"
      >
        <v-card>
          <v-card-title>
            Notifications
          </v-card-title>
          <v-card-subtitle>
            Choose who you would like to receive email notifications. These are for things like new registrations and candidate document uploads.
            If nobody is selected the email in the details section will be used.<br>(Currently: {{ settings.email }}).
          </v-card-subtitle>
          <v-card-text>
            <v-autocomplete
              v-model="settings.users_to_notify"
              :items="userEmails"
              label="Users"
              item-text="full_name"
              item-value="id"
              chips
              small-chips
              multiple
              clearable
              outlined
              attach
              @change="changed()"
            >
              <v-list-item slot="prepend-item">
                <v-list-item-action>
                  <v-btn
                    color="primary"
                    @click="selectAll()"
                  >
                    Select all
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <template v-slot:selection="data">
                <v-chip>
                  <v-avatar left>
                    <v-icon>
                      mdi-account-circle-outline
                    </v-icon>
                  </v-avatar>
                  {{ data.item.first_name }} {{ data.item.last_name }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="6"
        class="d-flex align-stretch"
      >
        <v-card>
          <v-card-title>
            Document upload notes
          </v-card-title>
          <v-card-subtitle>
            Below you can enter a custom message which is displayed to all candidates when they upload a document. This is useful for explaining what documents you require and why.
          </v-card-subtitle>
          <v-card-text>
            <wysiwyg
              v-model="settings.document_upload_notes"
              @change="changed()"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        class="d-flex align-stretch"
      >
        <v-card
          :disabled="loading"
          class="card-width"
        >
          <v-card-title>
            Portal Customisation
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <label class="v-label v-label--active lblCustom">
                  Logo Preview
                </label>
                <drag-drop-file-upload-component
                  :settings="settings"
                  :show-errors="showErrors"
                  :errors="errors"
                  @imageSelected="fileUpload('logo', $event)"
                />
                <div
                  v-if="logo_error"
                  id="logoError"
                  class="inlineError"
                >
                  {{ logo_error_text }}
                </div>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="d-flex flex-wrap flex-column align-center"
              >
                <div>
                  <label class="v-label v-label--active lblCustom">
                    Branding Colour
                  </label>
                </div>
                <div class="d-flex mt-2">
                  <v-skeleton-loader
                    v-if="loading"
                    width="400"
                    type="image"
                  />
                  <v-color-picker
                    v-else
                    ref="picker"
                    v-model="settings.hsl"
                    mode="hexa"
                    hide-canvas
                    width="400"
                    flat
                    hide-mode-switch
                    :swatches="colorSet"
                    show-swatches
                    @update:color="changed(true)"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="$store.state.agencies.agency.flo_customer">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row class="">
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  :value="$store.state.agencies.agency.flo_url"
                  label="Flo URL"
                  readonly
                  disabled
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  :value="$store.state.agencies.agency.api_key"
                  label="Flo API Key"
                  readonly
                  disabled
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </div>
</template>
<script>
export default {
  name: 'AgencySettingsComponent',
  props: {
  },
  data: () => ({
    loading: true,
    initialSettings: null,
    settings: {
      id: '',
      logo: '',
      phone: '',
      email: '',
      address: '',
      primary_colour: '',
      bank_name: '',
      account_number: '',
      sort_code: '',
      website_url: '',
      twitter_handle: '',
      facebook_page: '',
      linkedin_profile: '',
      work_finders_agreement: '',
      terms_conditions: '',
      document_upload_notes: ''
    },
    colorSet: [
      ['#d11a11'],
      ['#62B814'],
      ['#0686d8']
    ],
    work_finders_agreement: null,
    terms_conditions_url: null,
    apikey: '',
    showErrors: false,
    errors: {},
    errorsArray: [],
    errorMsg: false,
    wfa_error: false,
    wfa_error_text: '',
    tnc_error: false,
    tnc_error_text: '',
    logo_error: false,
    logo_error_text: ''
  }),
  computed: {
    userEmails () {
      return this.$store.state.users.users
    },
    storageRoot () {
      return process.env.MIX_STORAGE_URL
    },
    hasChanges () {
      return JSON.stringify(this.settings) !== JSON.stringify(this.initialSettings)
    },
    color: {
      get () {
        return this[this.settings.hsl]
      },
      set (v) {
        this[this.settings.hsl] = v
      }
    }
  },
  created () {
    const self = this
    self.LoadStateDependencies(['agencies.agency']).then(
      () => {
        self.settings = self.$store.state.agencies.agency.settings
        self.settings.hsl = {
          h: parseInt(self.settings.primary_colour),
          s: parseFloat(self.settings.saturation),
          l: parseFloat(self.settings.lightness)
        }
        self.initialSettings = JSON.parse(JSON.stringify(self.settings))
        self.loading = false
      })
    self.$store.dispatch('users/setUsers')
  },
  methods: {
    fileUpload ($type, $file) {
      const self = this
      self.loading = true
      self.restFileInput()
      const formData = new FormData()
      formData.append('id', self.settings.id)
      formData.append('file', $file)
      formData.append('type', $type)
      axios.post(self.URLs.core.agencySettings.updateFileWithId(self.settings.agency_id), formData)
        .then(response => {
          self.loading = false
          self.$store.dispatch('agencies/setAgency').then(
            () => {
              self.settings = self.$store.state.agencies.agency.settings
              self.settings.hsl = {
                h: parseInt(self.settings.primary_colour),
                s: parseFloat(self.settings.saturation),
                l: parseFloat(self.settings.lightness)
              }
              this.$emit('form-changed', true)
            }
          )
        })
        .catch(error => {
          switch ($type) {
            case 'wfa':
              self.wfa_error = true
              self.wfa_error_text = error.response.data.message
              break
            case 'terms' :
              self.tnc_error = true
              self.tnc_error_text = error.response.data.message
              break
            case 'logo' :
              self.logo_error = true
              self.logo_error_text = error.response.data.message
          }
          self.loading = false
        })
    },
    onInput (hue) {
      this.settings.primary_colour = hue
    },
    setErrors (data) {
      if (_.isString(data)) {
        var tempDiv = document.createElement('div')
        tempDiv.innerHTML = data
        this.errors = { message: tempDiv.getElementsByTagName('title')[0].innerHTML }
      } else if (_.isArray(data)) {
        this.errorsArray = data
        this.errors = {}
      } else {
        this.errors = data
        this.errorsArray = []
      }
    },
    clear () {
      this.showErrors = false
      this.errors = {}
      this.errorsArray = []
    },
    nullOrUndefined (value) {
      this.restFileInput()
      return _.isNull(value) || _.isUndefined(value)
    },
    selectAll () {
      var $ids = _.map(this.$store.state.users.users, 'id')
      this.settings.users_to_notify = $ids
      this.changed()
    },
    changed ($force) {
      if ($force) {
        this.$emit('form-changed', $force)
      } else {
        this.$emit('form-changed', this.hasChanges)
      }
      this.restFileInput()
    },
    restFileInput () {
      this.logo_error = false
      this.tnc_error = false
      this.wfa_error = false
      this.wfa_error_text = ''
      this.tnc_error_text = ''
      this.logo_error_text = ''
    }
  }
}
</script>
<style lang="scss">
#AgencySettingsComponent {
  .logo-background {
    background: url('/img/flo_placeholder.png') center no-repeat;
    background-size: contain;
  }
  .v-color-picker{
    border: 1px solid #ccc;
    height: 281px;
    .v-color-picker__preview {
      flex-direction: column;
      .v-color-picker__dot {
        margin: 20px;
        width: 50px;
        height: 50px;
      }
      .v-color-picker__sliders {
        width: 100%;
      }
    }
  }
  .apikey{
    margin: 1.5rem 1rem 0.5rem;
  }
  .card-width{
    width: 100%;
  }
  @media only screen and (min-width: 960px) {
    .align-bottom {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
    #wfaError{
        margin-left: 15px;
        font-size: 12px;
        overflow: hidden;
        color: red;
        position: relative;
        top: -18px;
        left: 19px;

    }
    #tncError{
        margin-left: 15px;
        font-size: 12px;
        color: red;
        position: relative;
        overflow: hidden;
        top: -36px;
        left: 21px;
    }
    #logoError{
        margin-left: 15px;
        font-size: 12px;
        color: red;
        position: relative;
        top: 4px;
        overflow: hidden;
    }
}
</style>
